import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const FinalConsiderations = () => (
  <View id="6">
    <Text bold size="small">
      6 DISCUSSÃO DO PLANO DE AÇÃO E CONSIDERAÇÕES FINAIS
    </Text>

    <Text>
      O principal objetivo deste trabalho foi fornecer dados sobre a exposição ocupacional a que estão sujeitos os
      trabalhadores.
    </Text>
    <Text>
      A responsabilidade técnica do presente documento, que foi confeccionado pelos profissionais assinados ao final,
      restringe-se exclusivamente as avaliações e recomendações realizadas pelo mesmo, ficando sob inteira
      responsabilidade da Empresa a implantação e acompanhamento das medidas de proteção.
    </Text>
    <Text>
      As Conclusões deste programa referem-se a avaliações de riscos realizadas no ambiente de trabalho,{' '}
      <u>
        baseadas nas informações (Relação de funcionários, descritivos de funções, descrição dos métodos de trabalhos)
        prestadas pela a empresa. Caberá a mesma sempre informar situações como
      </u>{' '}
      mudanças de processo, equipamentos, ferramentas de trabalho, arranjo físico ou outras situações possam gerar
      riscos aos trabalhadores, solicitando nova avaliação dos agentes citados neste programa.
    </Text>
    <Text></Text>
    <Separator weight={8} />
  </View>
)

export default FinalConsiderations
